module.exports = __webpack_public_path__ + "fonts/sourcesansproblack.6e1796be.woff2";